<div class="content">
  <fa-icon [icon]="['fal', 'check-circle']" size="2x" [fixedWidth]="true"> </fa-icon>
  <div>
    <h3>{{ header }}</h3>
    @if (body.length > 0) {
      <p>{{ body }}</p>
    }
  </div>
</div>
